import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { pickupSettingsRouter } from './routing/pickupSettingsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { pickupSettingsAccessControl } from './access-control/pickupSettingsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'pickup-settings',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'pickup-settings-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [pickupSettingsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsGeneral,
      attachToV3: NavEntryPointV3.Stores,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Configure pickup location settings and preferences for store operations',
          labelId: 'pickupSettingsDomain.title',
          route: 'pickup-settings',
          accessControl: pickupSettingsAccessControl,
          id: 'nav-item-pickupSettings',
          positionNavV2: 2,
          positionNavV3: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
